module.exports = __webpack_public_path__ + "static/media/badge_highfive_3.22f23ac6.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_highfive_3.png
// module id = 512
// module chunks = 0